import { render, staticRenderFns } from "./gallerySlideWide.vue?vue&type=template&id=48c300bc&scoped=true&"
import script from "./gallerySlideWide.vue?vue&type=script&lang=js&"
export * from "./gallerySlideWide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c300bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
